import { parseCardsForFeature } from '@/assets/scripts/parsers/cards'
import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'
import { PATRIMONY_COLORS, PATRIMONY_COLORS_DARK } from '@/assets/constants/core'
import { useI18n } from 'vue-i18n'

/** returns number of operations to sign
@return { Object }
*/
export const getSignListCounter = state => state.signListCounter

/** returns Home Balances
@return { Object }
*/
export const getPatrimonyInfo = state => state.patrimonyInfo

/** returns Home Accounts
@return { Array }
*/
export const getHomeAccounts = state => state.homeAccounts

/** returns Cards list
@return { Array }
*/
export const getCardsList = state => {
    return parseCardsForFeature(state.cardsList).map(card => {
        return {
            ...card,
            productName: card.product,
            cardDescription: card.friendlyName.length ? card.friendlyName : null,
            availableBalance: card.accountingBalance,
            cardBalance: card.balance,
            cardCurrency: card.currency
        }
    })
}

/** returns Accounts List
@return { Array }
*/
export const getAccountsList = state => parseAccountsForFeature(state.accountsList)

/** returns Cashflow info
@return { Object }
*/
export const getCashflowInfo = state => state.cashflowInfo

/** returns Home Movements
@return { Array }
*/
export const getAccountMovements = state => state.homeMovements

/** returns last naHora transfers
@returns { Array }
*/
export const getLastNaHoraTransfers = state => state.lastNaHoraTransfersList

/** returns exchange table list
@return { Array }
*/
export const getExchangeTableList = state => state.exchangeTableList

/** returns exchange table with value list
@return { Array }
*/
export const getExchangeTableWithValue = state => state.exchangeTableWithValue

/** returns last update date
@return { String }
*/
export const getLastUpdateDate = state => state.lastUpdateDate

/** returns Dashboard Cards
@return { Array }
*/
export const getDashboardCards = state => state.dashboardCards

/** returns tpas requested list
@return { String }
*/
export const getTPAsList = state => state.tpasList

/** returns list of operators
@return { String }
*/
export const getOperatorsList = state => state.operatorsList

/** returns frequent operations
@return { String }
*/
export const getFrequentOperations = state => state.frequentOperations

/** returns patrimony accounts products List
@currency { String }
@return { Array }
*/
export const getAccountsProductsList = state => (currency, appMode) => {
    const products = state.patrimonyInfo.accountTypes.map((product, index) => {
        return {
            ...product,
            color: appMode === 'dark' ? PATRIMONY_COLORS_DARK[index] : PATRIMONY_COLORS[index]
        }
    })

    if (!currency || currency === 'allCurrencies') return products

    /* If we are filtering by currency we need to validate which accounts have them, and which type they are */
    const accounts = state.patrimonyInfo.accounts.filter(account => account.accountCurrency === currency)

    const newProducts = products.reduce((acc, product) => {
        if (accounts.find(account => account.accountType === product.id)) acc.push(product)
        return acc
    }, [])

    return newProducts
}

/**
* creating list of accounts based on received params
@currency { String }
@product { String }
@assetOrLiability { String }
*/
export const getPatrimonyAccountsList = state => (currency, product, assetOrLiability) => {
    // we will add a prop named description to account, to match product params named
    let accounts = state.patrimonyInfo.accounts.map(account => {
        return {
            ...account,
            description: account.accountDescription
        }
    })

    if (currency) accounts = accounts.filter(obj => obj.accountCurrency === currency)
    if (product && product !== 'allProducts') accounts = accounts.filter(obj => obj.accountType === product)
    if (assetOrLiability) accounts = accounts.filter(obj => obj.accountFinancialType === (assetOrLiability === 'assets' ? 'ASSET' : 'LIABILITY'))

    return accounts
}

/*
* Parsing info provided to match dropdown obj params
*/
export const getCurrenciesList = state => {
    const { t } = useI18n()

    const currenciesDropList = state.patrimonyInfo.currenciesFromAccounts.map(currency => {
        return {
            ...currency,
            currency: currency.name
        }
    })

    if (currenciesDropList.length === 1) {
        currenciesDropList[0].isSelected = true
    } else {
        currenciesDropList.unshift({ currency: 'allCurrencies', description: t('accounts.patrimony.labels.allCurrencies'), isSelected: true })
    }

    return currenciesDropList
}
